import * as React from "react";

function SvgComponent(props) {
  return (
    <svg width={18} height={18} fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 31.1c-141.4 0-255.1 93.09-255.1 208c0 49.59 21.38 94.1 56.97 130.7c-12.5 50.39-54.31 95.3-54.81 95.8c-2.187 2.297-2.781 5.703-1.5 8.703c1.312 3 4.125 4.797 7.312 4.797c66.31 0 116-31.8 140.6-51.41c32.72 12.31 69.01 19.41 107.4 19.41c141.4 0 255.1-93.09 255.1-207.1S397.4 31.1 256 31.1zM232 136C232 122.8 242.8 112 256 112s24 10.75 24 24v112c0 13.25-10.75 24-24 24S232 261.3 232 248V136zM256 368c-17.67 0-32-14.33-32-32c0-17.67 14.33-32 32-32s32 14.33 32 32C288 353.7 273.7 368 256 368z" fill="#757575"/></svg>
  );
}

export default SvgComponent;
